import * as React from 'react';
import Svg, { Path } from 'react-native-svg';
const HelpWhite = (props) => (<Svg width={props.width || '100%'} height={props.height || '100%'} viewBox="0 0 16 16" fill="none" {...props}>
    <Path fill="#fff" stroke="#fff" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.12} d="M8 13.6A5.6 5.6 0 1 0 8 2.4a5.6 5.6 0 0 0 0 11.2Z"/>
    <Path stroke="#0B1F2C" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.12} d="M8 10.8h.005M6.37 6.32a1.68 1.68 0 0 1 3.265.56c0 1.12-1.68 1.68-1.68 1.68"/>
  </Svg>);
export default HelpWhite;
